import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = {
  key: 0,
  class: "submit-error"
}
const _hoisted_11 = {
  key: 1,
  class: "submit-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_circle_loader = _resolveComponent("circle-loader")!
  const _component_base_form_field = _resolveComponent("base-form-field")!
  const _component_next_button = _resolveComponent("next-button")!
  const _component_step = _resolveComponent("step")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    allowCloseBtn: true,
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading || _ctx.gettingData)
        ? (_openBlock(), _createBlock(_component_circle_loader, { key: 0 }))
        : (_openBlock(), _createBlock(_component_step, { key: 1 }, {
            header: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Confirm School Information", -1)
            ]))]),
            actions: _withCtx(() => [
              _createVNode(_component_next_button, {
                loading: _ctx.loading || _ctx.savingChanges,
                disabled: _ctx.loading || _ctx.savingChanges,
                onClick: _ctx.goBackToPortal,
                text: "Save Changes"
              }, null, 8, ["loading", "disabled", "onClick"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_base_form_field, {
                    modelValue: _ctx.schoolInfo.schoolName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.schoolInfo.schoolName) = $event)),
                    schema: _ctx.schema.schoolName,
                    disabled: _ctx.readOnlyField,
                    "read-only": _ctx.readOnlyField
                  }, null, 8, ["modelValue", "schema", "disabled", "read-only"])
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_base_form_field, {
                    modelValue: _ctx.schoolInfo.academicTerm,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schoolInfo.academicTerm) = $event)),
                    modelModifiers: { string: true },
                    schema: _ctx.schema.academicTerm,
                    disabled: _ctx.readOnlyField,
                    "read-only": _ctx.readOnlyField
                  }, null, 8, ["modelValue", "schema", "disabled", "read-only"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createVNode(_component_base_form_field, {
                    modelValue: _ctx.schoolInfo.enrollmentStatusId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schoolInfo.enrollmentStatusId) = $event)),
                    schema: _ctx.schema.enrollmentStatusId,
                    options: _ctx.enrollmentStatusOptions
                  }, null, 8, ["modelValue", "schema", "options"]), [
                    [_vShow, _ctx.schoolInfo.academicTerm]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_base_form_field, {
                    modelValue: _ctx.schoolInfo.graduationDateMonth,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.schoolInfo.graduationDateMonth) = $event)),
                    schema: _ctx.schema.graduationDateMonth,
                    options: _ctx.months()
                  }, {
                    "default-option": _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Month", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "schema", "options"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_base_form_field, {
                    modelValue: _ctx.schoolInfo.graduationDateYear,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.schoolInfo.graduationDateYear) = $event)),
                    schema: _ctx.schema.graduationDateYear,
                    options: _ctx.years(true)
                  }, {
                    "default-option": _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Year", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "schema", "options"])
                ])
              ]),
              (_ctx.invalidEnrollmentTerm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("p", null, "Graduation Date must be after the selected Academic Period.", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["onClose"]))
}